import {StatusChange} from '../components/ListComponents';
import {WHITE_HEX} from '../consts';
import {Record} from '../../../../../../stores/Form/Record';
import {ChangeType} from '../components/enums';

export enum StatusField {
    Time = 1,
    Status = 2,
    Assignee = 3,
    User = 5
}

const getInitials = (userName: string) => {
    return userName[0].toUpperCase();
};

const getFieldValue = (status: Record, fieldNum: StatusField) => {
    return status.getField(fieldNum).origValue.toString();
};

const generateCreationStatusObj = (status: Record): StatusChange => {
    const userName = getFieldValue(status, StatusField.User);

    return {
        type: ChangeType.Created,
        key: status.clientKey,
        user: userName,
        initials: getInitials(userName),
        time: getFieldValue(status, StatusField.Time)
    };
};

const getGeneralStatusData = (record: Record, userName: string) => {
    return {
        key: record.clientKey,
        user: userName,
        initials: getInitials(userName),
        time: getFieldValue(record, StatusField.Time)
    };
};

const getStatusColr = (statusName: string, statusColorMap: any) => {
    const mpaItem = statusColorMap.find(i => i.Statdes === statusName);
    return mpaItem ? mpaItem.Color : WHITE_HEX;
};

const getStatusChangeData = (statusValue: string, record: Record, statusColorMap: any) => {
    return {
        currValue: statusValue,
        fieldName: record.parentForm.getColumnByID(StatusField.Status).Title,
        color: getStatusColr(statusValue, statusColorMap)
    };
};

const compareStatuses = (currRec: Record, prevRec: Record, statusColorMap): StatusChange => {
    const currStatus = getFieldValue(currRec, StatusField.Status);
    const prevStatus = getFieldValue(prevRec, StatusField.Status);
    const currAssignee = getFieldValue(currRec, StatusField.Assignee);
    const prevAssignee = getFieldValue(prevRec, StatusField.Assignee);
    const userName = getFieldValue(currRec, StatusField.User);

    if (currStatus !== prevStatus && currAssignee !== prevAssignee) {
        return {
            ...getGeneralStatusData(currRec, userName),
            type: ChangeType.Multiple,
            changes: [
                {...getStatusChangeData(currStatus, currRec, statusColorMap)},
                {
                    fieldName: currRec.parentForm.getColumnByID(StatusField.Assignee).Title,
                    prevValue: prevAssignee,
                    currValue: currAssignee
                }
            ]
        };
    } else if (currStatus !== prevStatus) {
        return {
            ...getGeneralStatusData(currRec, userName),
            type: ChangeType.Status,
            changes: [getStatusChangeData(currStatus, currRec, statusColorMap)]
        };
    } else if (currAssignee !== prevAssignee) {
        return {
            ...getGeneralStatusData(currRec, userName),
            type: ChangeType.Assign,
            changes: [
                {
                    fieldName: currRec.parentForm.getColumnByID(StatusField.Assignee).Title,
                    prevValue: prevAssignee,
                    currValue: currAssignee
                }
            ]
        };
    } else {
        return null;
    }
};

export const checkStatusChange = (
    statuses: Record[],
    idx: number,
    shouldFetchMore: boolean,
    statusColorMap: any[]
): StatusChange => {
    if (idx === statuses.length - 1) {
        if (shouldFetchMore) {
            return null;
        } else {
            return generateCreationStatusObj(statuses[idx]);
        }
    } else {
        return compareStatuses(statuses[idx], statuses[idx + 1], statusColorMap);
    }
};
